import React, { useState, useEffect, forwardRef, useRef, useImperativeHandle } from "react";
import ReactDOM from 'react-dom';
import { useTranslation } from 'react-i18next';
import Select from 'react-select'

const IncomingClassCategoryTypeEditor = forwardRef((props, ref) => {
    const [selectedVal, setSelectedVal] = useState(props.value);

    const [editing, setEditing] = useState(true);
    const refContainer = useRef(null);
    const refSelectInput = useRef(null);
    const { t } = useTranslation();


    useEffect(() => {
        focus();
        var myDataInvoiceType=null;
        if(props.colDef.cellRendererParams && props.colDef.cellRendererParams.myDataInvoiceType){
            myDataInvoiceType=props.colDef.cellRendererParams.myDataInvoiceType
        }
        else{
            myDataInvoiceType=props.data.invoiceType?props.data.invoiceType.myDataInvoiceType:null;
        }
        if (myDataInvoiceType == null) {
            props.api.stopEditing();
        }
    }, []);

    useImperativeHandle(ref, () => {
        return {
            getValue() {
                return selectedVal != null ? selectedVal : props.value;
            },

            isPopup() {
                return true;
            }
        };
    });
    useEffect(() => {
        if (!editing) {
            props.api.stopEditing();
        }
    }, [editing]);

    const focus = () => {
        window.setTimeout(() => {
            let container = ReactDOM.findDOMNode(refContainer.current);
            if (container) {
                container.focus();
            }
        });
    };


    const onSelectChange = val => {

        var old_val=props.node.data.classificationCategory.value;
        setSelectedVal(val);
        setTimeout(function () {
            props.api.stopEditing();                    
            props.node.setDataValue("classificationCategory", val);
            var opts = [];
            val.classificationValues.forEach(element => {
                opts.push({
                    value: element,
                    label: t(element) + " (" + element + ")",
                });
            });

            props.node.setDataValue("classificationValues", opts);
            if(old_val!=val.value){              
                props.node.setDataValue("classificationValue", { value: undefined, label: undefined });
            }
        })
    }
    const onMouseOver = e => {
        refSelectInput.current.setState({ isOpen: true })
        let container = ReactDOM.findDOMNode(e.target).parentNode.getElementsByTagName("input")[0];
        if (container != undefined) {
            container.focus();
        }
    }

    const getOptions=()=>{
        if(props.data.selfPricing){
            if(props.colDef.cellRendererParams && props.colDef.cellRendererParams.myDataInvoiceType){
                return props.colDef.cellRendererParams.expensesClassCategories
            }
            else{
                return props.data.classificationCategoryTypes
            }
        }
        else{
            if(props.colDef.cellRendererParams && props.colDef.cellRendererParams.myDataInvoiceType){
                return props.colDef.cellRendererParams.incomeClassCategories
            }
            else{
                return props.data.classificationCategoryTypes
            }
        }        
    }

    return (<div style={{ width: props.column.actualWidth + 'px' }}>

        <span onMouseOver={onMouseOver} className="selectCell" ref={refContainer}>
            <Select
                autosize={true}
                menuIsOpen={true}
                defaultValue={selectedVal}
                onChange={onSelectChange}
                onChangeValue={onSelectChange}
                menuPortalTarget={document.body}
                styles={{
                    menu: (provided, state) => ({
                        ...provided,
                        minWidth: 250,
                        border: '4px #333',
                        zIndex: 9999
                    }), menuPortal: base => ({ ...base, zIndex: 9999 })
                }}
                options={getOptions()} ref={refSelectInput} 
                >
            </Select>
        </span>
    </div>
    );
});

export default IncomingClassCategoryTypeEditor;